import React from "react";
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuTrigger,
  DropdownMenuItem,
  DropdownMenuSeparator,
} from "../components/ui/dropdown-menu";
import { FiMoreVertical } from "react-icons/fi";
import { Button } from "../components/ui/button";

interface Action {
  label: string;
  icon: React.ReactNode;
  onClick: () => void;
  variant?:
    | "default"
    | "destructive"
    | "outline"
    | "secondary"
    | "dropPlain"
    | "dropGreen"
    | "dropRed";
}

interface ActionDropdownProps {
  actions: Action[];
}

const ActionDropdown: React.FC<ActionDropdownProps> = ({ actions }) => {
  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <Button variant={"dropMenu"}>
          <FiMoreVertical />{" "}
        </Button>
      </DropdownMenuTrigger>
      <DropdownMenuContent
        align="end"
        sideOffset={5} // Add some offset from the trigger
        collisionPadding={20} // Add padding to avoid collisions with viewport edges
        className="w-48 bg-white border border-[#E5E7EB] rounded-lg shadow-md z-50"
      >
        {actions.map((action, index) => (
          <div key={index}>
            <DropdownMenuItem asChild>
              <Button
                variant={action.variant || "dropPlain"}
                onClick={action.onClick}
                className="flex items-left gap-2 w-full justify-start"
              >
                {action.icon}
                {action.label}
              </Button>
            </DropdownMenuItem>
            {index < actions.length - 1 && <DropdownMenuSeparator />}
          </div>
        ))}
      </DropdownMenuContent>
    </DropdownMenu>
  );
};

export default ActionDropdown;
